<div class="batch-loading-content">
  <div class="batch-loading-icon"><img alt="vessel" src="/assets/icons/icon_vessel_md.svg" /></div>
  <div class="batch-loading-header">{{ "BATCH_UPLOAD_IN_PROGRESS" | translate }}</div>
  <div class="batch-loading-header-hint">
    {{ "GREAT_NEWS" | translate }}
    <span class="batch-loading-header-hint-strong">{{ "SYSTEM_IS_CREATING_YOUR_FILINGS" | translate }}</span>
  </div>
  <div class="batch-loading-progress-bar">
    <div class="batch-loading-progress-bar-line">
      <div class="batch-loading-progress-bar-pending" [style.width]="currentProgress"></div>
    </div>
  </div>
  <div class="batch-loading-footer-hint">{{ "BATCH_PROCESS_MAY_TAKE_FEW_MINUTES" | translate }}</div>
</div>
